import { useState, useEffect } from 'react';
import { Reports } from '../apiTypes';
import { fetchReportById } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';


export function useReport(reportId?: string) {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [report, setReport] = useState<Reports | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId) return;

    const loadReport = async () => {
      setLoading(true);
      try {
        const data = await fetchReportById(reportId);
        setReport(data);
        setError(null);
      } catch (err) {
        setError('Errore caricamento report');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, [reportId]);

  return { report, loading, error };
}
